import classes from "../classes";
import expandable from "./higher-order/expandable";
import React from "react";
import TournamentListItemDetails from "../containers/tournament-list-item-details";
import TournamentListItemHeader from "../containers/tournament-list-item-header";
import { trackTournamentDetail } from "../analytics";

export default expandable(class TournamentListItem extends React.PureComponent {
  constructor(props) {
    super(props);
    var { tournament } = props;
    this.state = { allowEntry: !tournament.get("real_money") };
    this.toggleAllowEntry = this.toggleAllowEntry.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  toggleAllowEntry() {
    var { allowEntry } = this.state;
    this.setState({ allowEntry: !allowEntry }); // eslint-disable-line react/no-set-state
  }

  toggleExpanded() {
    var { expanded, position, toggle, tournament } = this.props;
    if (!expanded) {
      trackTournamentDetail("Tournament List", tournament, position);
    }
    toggle();
  }

  render() {
    var { expanded, position, tournament } = this.props;

    var details;
    if (expanded) {
      details = (<TournamentListItemDetails tournament={tournament} />);
    }
    return (
      <div className={classes({
        "tournament-table": true,
        "tournament-table--is-featured": tournament.get("featured"),
        "tournament-table--is-open": expanded
      })}>
        <TournamentListItemHeader
          position={position}
          toggle={this.toggleExpanded}
          tournament={tournament} />

        {details}
      </div>
    );
  }
});
